import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { WebPopService, State } from '../services';

export const webCapture = (webPop: WebPopService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (!state.system?.webCapture)
        return of([state, currentState] as [Partial<State>, State]);

      const { saveToQ, url, additionalVars } = state.system.webCapture;
      //this should hold progress until the iframe post back to txtresult
      return webPop.capture$(url, additionalVars).pipe(
        map(
          (data) =>
            [
              {
                ...state,
                ...{
                  system: {
                    ...state.system,
                    webCapture: undefined,
                  },
                  answers: [
                    ...state.answers!.slice(0, saveToQ),
                    data,
                    ...state.answers!.slice(saveToQ + 1),
                  ],
                },
              },
              currentState,
            ] as [Partial<State>, State]
        )
      );
    })
  );
